export default "<div class=\"body\">\n    <img  [src]=\"(content)\">\n</div>\n"